<template>
  <b-modal
    v-model="visible"
    title="Nuevo elemento para Recursos"
  >

    <b-form-group label="Título">
      <b-form-input
        placeholder="Título"
        v-model="post.titulo"
      />
    </b-form-group>
    <b-form-group label="Descripción">
      <b-textarea
        placeholder="Descripción"
        v-model="post.cuerpo"
      ></b-textarea>
    </b-form-group>
    <b-form-group label="Archivo">
      <b-form-file
        type="file"
        v-model="post.archivo"
      />
    </b-form-group>
    <template v-slot:modal-footer>
      <div class="w-100">
        <b-button
          variant="primary"
          class="float-right"
          @click="submit"
        >
          Aceptar
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapActions } from 'vuex'
export default {

  data () {
    return {
      visible: false,
      post: {
        id_categoria: null,
        titulo: '',
        cuerpo: '',
        archivo: null
      }
    }
  },

  methods: {
    ...mapActions(['fetchPostsRecursos']),
    submit () {
      const formData = new FormData();
      for (const index in this.post) {
        if (this.post[index]) {
          formData.append(index, this.post[index])
        }
      }

      this.$api.post('recursos/post', formData, {
        headers: {
          'Content-type': 'multipart/form-data'
        }
      }).then(() => {
        this.fetchPostsRecursos(this.post.id_categoria)
        this.visible = false
      })
    }
  },
  watch: {
    visible (val) {
      if (!val) {
        this.post = {
          id_categoria: null,
          titulo: '',
          cuerpo: ''
        }
      }
    }
  }
}
</script>
